import React from "react";

import { GenericLogs } from "../../../../components/GenericLogs/GenericLogs";
import { fetchMeetingLogsDetailed } from "./MeetingLogs.function";
import { transformMeetingLog } from "./MeetingLogs.transform";

const MeetingLogs = ({ meetingId, language }: { meetingId: string; language: string }) => (
  <GenericLogs
    entityId={meetingId}
    language={language}
    fetchLogs={fetchMeetingLogsDetailed}
    translationPrefix="PAGES.MEETING.LOGS.ATTRIBUTES"
    transformDetailedLog={transformMeetingLog}
    detailedConfig={{
      enabled: false,
      value: true,
      onToggle: () => null,
    }}
  />
);

export default MeetingLogs;
